"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSurveyContext = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const SurveyContext_1 = require("../../contexts/SurveyContext");
const withSurveyContext = (WrappedComponent) => 
/* eslint-disable-next-line react/display-name */
(props) => (react_1.default.createElement(SurveyContext_1.SurveyContext.Consumer, null, (context) => react_1.default.createElement(WrappedComponent, Object.assign({}, props, { surveyContext: context }))));
exports.withSurveyContext = withSurveyContext;
//# sourceMappingURL=WithSurveyContextHoc.js.map